/* LIBRARIES  */
import React from 'react'
import { DateTime } from 'luxon'
import { DI } from 'modules'
import { plural } from 'helpers/strings'

function PlanInfo({ common: { strings }, agreement }) {
  const allContentAccess = ['enterprise', 'enterprise_branded'].includes(
    agreement.agreement_type
  )
  const largeDuration = agreement.duration_unit === 'month'
  const prefix = 'page.video.slider'

  return (
    <div className="side-buy-plan__info">
      <p>
        {largeDuration &&
          plural(
            agreement.duration,
            strings[`${prefix}.enterprise.additions.months`]
          )}
        {allContentAccess &&
          strings[`${prefix}.enterprise.additions.all_content_access`]}
      </p>
      <p>
        {strings[`${prefix}.enterprise.additions.rights`]}
        {
          strings[
            `page.plan_details.rights_block.archiving_rights.${agreement.archiving_rights}`
          ]
        }
      </p>
      {agreement.auto_renewal && (
        <p>
          {strings[`${prefix}.enterprise.additions.valid_till`]}
          {DateTime.fromISO(agreement.expires_at).toFormat(
            strings[`${prefix}.date.format`]
          )}
        </p>
      )}
    </div>
  )
}

export default DI([])(PlanInfo)
